import createCache from '@emotion/cache';
import { createRoot } from 'react-dom/client';
// import "../../sass/main.scss"
// import styles from '../index.css'

export const buildShadowDomGivenRoot = (root: Element) => {
  const shadowRoot = root.attachShadow({ mode: 'open' });
  const _renderInShadowRoot = document.createElement('div');
  const emotionRoot = document.createElement('style');
  shadowRoot.appendChild(_renderInShadowRoot);
  shadowRoot.appendChild(emotionRoot);

  const cache = createCache({
    key: 'css',
    prepend: true,
    container: emotionRoot,
  });
  const renderInShadowRoot = createRoot(_renderInShadowRoot);
  return { shadowRoot, renderInShadowRoot, cache };
};

/**
 * We need this function to encode the redirectUrl that we pass to the WP login page.
 * We can't pass the # symbol in the url, as it will be ignored from the searchParams,
 * @param redirectUrl 
 * @returns 
 */
export const encodeRedirectUrl = (redirectUrl: string) => {
  const maskedUrl = redirectUrl.replace('/#/', '/deli/');
  return maskedUrl;
};

/**
 * We need this function to decode the redirectUrl that we get from the WP login page. 
 * We can't pass the # symbol in the url, as it will be ignored from the searchParams,
 * so we replace it with /deli/ and then we decode it here.  
 * @param maskedUrl: string
 * @returns redirectUrl: string
 * 
 */
export const decodeRedirectUrl = (maskedUrl: string) => {
  const redirectUrl = maskedUrl.replace('/deli/', '/#/');
  return redirectUrl;
};
